module.exports = __webpack_public_path__ + "static/media/referal-bonus.dec22ab5.svg";